module.exports = __webpack_public_path__ + "img/583f822.jpg";